import React from 'react';
import { observer } from "mobx-react-lite";
import { ActionScope, CalculateVariableOperator, calculateVariableOperatorLiterals } from '../../../../shared/action/ActionModel';
import { ScopeSelectionActionDetail } from './components/ScopeSelectionActionDetail';
import { isNumberVariableInScope } from './ConditionActionDetails';
import { Dropdown } from '../../editor/Dropdown';
import { isBlank } from "../../../../shared/helper/generalHelpers";
import { sharedStore } from '../../../stores/SharedStore';
import { Input } from '../../editor/Input';
import { getTreeParent } from '../../../../shared/action/ActionTreeModel';
import { editorStore } from '../../../stores/EditorStore';
import { ElementGroup } from './components/BaseElements';
const ActionParameterSelectVariable = observer(({
  parentTree,
  variable,
  variableSetter
}) => {
  const {
    mainGameRootActionTree
  } = sharedStore;
  const globalVariables = [...mainGameRootActionTree.variableNames(ActionScope.Global)].filter(v => isNumberVariableInScope(parentTree, v, ActionScope.Global));
  const localVariables = [...parentTree.variableNames(ActionScope.Tree)].filter(v => isNumberVariableInScope(parentTree, v, ActionScope.Tree));
  const allVariables = [...new Set([...localVariables, ...globalVariables])];
  return /*#__PURE__*/React.createElement(Dropdown, {
    className: isBlank(variable) ? "invalid" : "",
    value: variable,
    onChange: ({
      target
    }) => variableSetter(target.value)
  }, allVariables.map(variableName => /*#__PURE__*/React.createElement("option", {
    key: variableName,
    value: variableName
  }, variableName)));
});
export const CalculateVariableActionDetails = observer(({
  action
}) => {
  const parentTree = getTreeParent(action);
  return /*#__PURE__*/React.createElement(React.Fragment, null, editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(ScopeSelectionActionDetail, {
    scope: action.scope,
    scopeSetter: action.setScope.bind(action)
  }), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ActionParameterSelectVariable, {
    variable: action.variable1,
    variableSetter: action.setVariable1.bind(action),
    parentTree: parentTree
  }), "\xA0", /*#__PURE__*/React.createElement(Dropdown, {
    value: action.operator,
    onChange: ({
      target
    }) => action.setOperator(parseInt(target.value))
  }, Object.keys(CalculateVariableOperator).filter(value => !Number.isNaN(Number(value))).map(op => /*#__PURE__*/React.createElement("option", {
    key: op,
    value: op
  }, calculateVariableOperatorLiterals[+op]))), "\xA0", /*#__PURE__*/React.createElement(ActionParameterSelectVariable, {
    variable: action.variable2,
    variableSetter: action.setVariable2.bind(action),
    parentTree: parentTree
  }), "\xA0=\xA0", /*#__PURE__*/React.createElement(Input, {
    className: isBlank(action.variableResult) ? "invalid" : "",
    type: "text",
    value: action.variableResult,
    onChange: ({
      target
    }) => action.setVariableResult(target.value)
  })));
});